import React from 'react';
import { Row } from 'react-bootstrap';
import styles from './Footer.module.css';
import logo from '../../assets/logos/logo-white.png';

const Footer = () => {
  const goTopOfPage = () => {
    window.scrollTo(0, 0);
  };

  return (
    <div className={styles.footer}>
      <Row className={styles.top}>
        <div className={styles['button-wrapper']}>
          <button type="button" className={styles.button} onClick={goTopOfPage}>
            <div className={styles['to-top']}>
              ↑ <span className={styles.italic}>Back to Top</span>
            </div>
          </button>
        </div>
      </Row>
      <div className={styles.middle}>
        <div className={styles['mid-1']}>
          <img src={logo} alt="The Literacy Project" className={styles.logo} />
          <div className={styles['mid-1-text']}>
            <div>
              <a
                href="https://literacyproj.org"
                target="_blank"
                rel="noreferrer"
                className={styles['footer-link']}
              >
                literacyproj.org
              </a>
            </div>
            <div>525 Superior Avenue, Newport Beach, CA 92663</div>
          </div>
        </div>
        <div className={styles['mid-2']}>
          <div>
            <a
              href="https://literacyproj.org/contact-us"
              target="_blank"
              rel="noreferrer"
              className={styles['footer-link']}
            >
              Contact Administration |{' '}
            </a>
            <a
              href="https://literacyproj.org/privacy-policy"
              target="_blank"
              rel="noreferrer"
              className={styles['footer-link']}
            >
              Privacy Policy
            </a>
          </div>
          <div>
            PHONE:
            <a
              href="tel:+19497211319"
              target="_blank"
              rel="noreferrer"
              className={styles['footer-link']}
            >
              949.721.1319
            </a>
          </div>
        </div>
      </div>
      <Row className={styles.bottom}>
        <div className={styles.copyright}>
          Copyright ©2023, The Literacy Project. All Rights Reserved.
        </div>
      </Row>
    </div>
  );
};

export default Footer;
